import React from 'react';

import { useIsQAlityConfiguredContextValue } from '@qality/common-components/src/lib/QAlityPageConfiguration';
import CreateIssueTypeExplanationBanner from '@qality/common-components/src/molecules/CreateIssueTypeExplanationBanner';
import EditableFolderName from '@qality/common-components/src/molecules/EditableFolderName/EditableFolderName';
import { FEATURE_FLAG } from '@qality/common-config';

import { CreateFolderModalButton } from '../CreateFolderModalButton';
import { useTestCaseRepositoryFoldersContext } from '../TestCaseRepositoryFoldersProvider';
import { ALL_TEST_CASES } from '../TestCaseRepositoryPage.const';
import { CreateTestCaseButton } from './CreateTestCaseButton';
import { FolderMenuDropdown } from './FolderMenuDropdown';
import { ImportButton } from './ImportButton';
import { OpenDocumentationButton } from './OpenDocumentationButton';
import { ShowIssueNavigatorButton } from './ShowIssueNavigatorButton';
import {
  ActionsStyled,
  ContainerStyled,
  EditableHeaderStyled,
  StaticHeaderStyled,
} from './TestCaseRepositoryHeader.styled';
import { TotalIssues } from './TotalIssues';

const NAME_SUFFIX = FEATURE_FLAG.isPremium ? 'Plus' : '';

export const TestCaseRepositoryHeader = (): JSX.Element => {
  const { currentFolder, currentView } = useTestCaseRepositoryFoldersContext();
  const isQAlityConfigured = useIsQAlityConfiguredContextValue();

  if (!isQAlityConfigured) {
    return (
      <ContainerStyled>
        <StaticHeaderStyled>
          {ALL_TEST_CASES}
          <TotalIssues />
        </StaticHeaderStyled>
        <CreateIssueTypeExplanationBanner nameSuffix={NAME_SUFFIX} />
      </ContainerStyled>
    );
  }

  if (currentView === 'all-test-cases') {
    return (
      <ContainerStyled>
        <ContainerStyled>
          <StaticHeaderStyled>
            {ALL_TEST_CASES}
            <TotalIssues />
          </StaticHeaderStyled>
          <ActionsStyled>
            <ImportButton />
            <ShowIssueNavigatorButton />
            <CreateTestCaseButton />
          </ActionsStyled>
        </ContainerStyled>
      </ContainerStyled>
    );
  }

  return (
    <ContainerStyled>
      <EditableHeaderStyled>
        <EditableFolderName
          folder={currentFolder}
          elementAfter={<TotalIssues />}
        />
      </EditableHeaderStyled>
      <ActionsStyled>
        <CreateFolderModalButton parentFolder={currentFolder} />
        <FolderMenuDropdown />
        <OpenDocumentationButton />
        <CreateTestCaseButton />
      </ActionsStyled>
    </ContainerStyled>
  );
};
